<template>
  <b-card
    no-body
    class="mb-2 shadow-sm border-0 ai-card anomaly-card"
    role="button"
    tabindex="0"
    :aria-label="ariaLabel"
    @click="onActivate"
    @keydown.enter.prevent="onActivate"
    @keydown.space.prevent="onActivate"
  >
    <div class="card-body p-3">
      <div class="d-flex align-items-center mb-2">
        <b-icon-exclamation-triangle class="mr-2 text-danger" font-scale="1.2" aria-hidden="true" />
        <h6 class="m-0 font-weight-bold text-uppercase" style="font-size: 13px;">Triangulation anomaly</h6>
        <b-icon-info-circle class="ml-auto text-muted" v-b-tooltip.hover.html="tooltipHtml" />
      </div>
      <p class="small mb-1">
        <strong>Max difference: {{ anomaly.diffPercent }}%</strong>
        between
        <span class="text-muted">{{ maxName }}</span>
        and
        <span class="text-muted">{{ minName }}</span>.
      </p>
      <p v-if="explanation" class="small text-muted mb-2">{{ explanation }}</p>
      <div class="text-right">
        <b-button
          size="sm"
          variant="outline-danger"
          class="mt-2"
          :aria-label="'Highlight conflicting sources: ' + maxName + ' and ' + minName"
          @click.stop="onActivate"
        >
          Highlight sources
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'AnomalyCard',
  props: {
    anomaly: {
      type: Object,
      required: true,
    },
    explanation: {
      type: String,
      default: '',
    },
    whyMatters: {
      type: String,
      default: '',
    },
  },
  computed: {
    maxName() {
      return this.strip(this.anomaly.maxSource && this.anomaly.maxSource.name);
    },
    minName() {
      return this.strip(this.anomaly.minSource && this.anomaly.minSource.name);
    },
    tooltipHtml() {
      const w = this.whyMatters ? `<div class="mt-1"><em>Why this matters:</em> ${this.whyMatters}</div>` : '';
      const c = '<div class="mt-1"><small>Confidence: based on visible chart series</small></div>';
      return `${this.explanation || ''}${w}${c}`;
    },
    ariaLabel() {
      return `Triangulation anomaly: sources differ by ${this.anomaly.diffPercent} percent. Press Enter to highlight conflicting series.`;
    },
  },
  methods: {
    strip(html) {
      if (!html) return '';
      return String(html).replace(/<[^>]*>/g, '').trim();
    },
    onActivate() {
      this.$emit('highlight-anomaly', this.anomaly);
    },
  },
};
</script>

<style scoped>
.ai-card {
  cursor: pointer;
}
.anomaly-card {
  border-left: 4px solid #dc3545 !important;
}
</style>
